<script setup>
import PrimeVueAvatar from 'primevue/avatar'
import Icon from '@/components/shared/icons/Icon.vue'
import {componentSizes} from '@/constants/components.js'
import {computed, toRefs} from 'vue'

//Emits and props
defineEmits([
  'click',
])
const props = defineProps({
  icon: {
    type: String,
    default: null,
  },
  label: {
    type: String,
    default: '',
  },
  size: {
    type: String,
    default: 'normal',
  },
  shape: {
    type: String,
    default: 'square',
  },
  image: {
    type: String,
    default: null,
  },
  imageAltText: {
    type: String,
    default: '',
  },
  isIconOutlined: {
    type: Boolean,
    default: false,
  },
})

//Icon size
const {size} = toRefs(props)
const iconSize = computed(() => {
  switch (size.value) {
    case 'large':
      return componentSizes.M
    case 'xlarge':
      return componentSizes.L
    case 'normal':
    default:
      return componentSizes.S
  }
})
</script>

<template>
  <PrimeVueAvatar
    :label="label"
    :shape="shape"
    :size="size"
    :class="{
      [$style.avatar]: true,
      [$style.withImage]: !!image,
    }"
    @click="$emit('click')"
  >
    <template
      v-if="icon"
      #icon
    >
      <Icon
        :icon="icon"
        :size="iconSize"
        :is-outlined="isIconOutlined"
      />
    </template>
    <template
      v-else-if="image"
      #icon
    >
      <div :class="$style.imageContainer">
        <img
          :src="image"
          :alt="imageAltText"
          :class="$style.image"
        >
      </div>
    </template>
  </PrimeVueAvatar>
</template>

<style module lang="scss">
.avatar {
  &.withImage {
    background: none;
  }
}
.imageContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  overflow: hidden;
}
.image {
  display: block;
  aspect-ratio: 1 / 1;
  object-fit: contain;
}
</style>
